<div class="themes">
    @for(theme of themes; track $index){
        <div class="theme">{{theme.nom}}</div>
    }
</div>